import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import axios from 'axios';

const API = 'https://app.b3rastreamento.com.br/api';

function Contratos() {
  const [sidebarAberta, setSidebarAberta] = useState(false);
  const [aba, setAba] = useState('contratos');
  const [contratos, setContratos] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [parceiros, setParceiros] = useState([]);
  const [modalEnviar, setModalEnviar] = useState(false);
  const [modalTemplate, setModalTemplate] = useState(false);
  const [templateEditando, setTemplateEditando] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [busca, setBusca] = useState('');
  const [linkGerado, setLinkGerado] = useState(null);
  const [tipoDestinatario, setTipoDestinatario] = useState('cliente'); // 'cliente' | 'parceiro'
  const [formEnviar, setFormEnviar] = useState({ cliente_id: '', parceiro_id: '', template_id: '', valor_mensal: '', dia_vencimento: '10', prazo_meses: '12', data_inicio: new Date().toISOString().split('T')[0], valor_por_rastreador: '', renovacao_automatica: true, observacao: '' });
  const [formTemplate, setFormTemplate] = useState({ nome: '', conteudo: '', tipo: 'cliente' });
  const [buscaCliente, setBuscaCliente] = useState('');
  const [mostrarSugestoes, setMostrarSugestoes] = useState(false);

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => { carregarDados(); }, []);

  const carregarDados = async () => {
    try {
      const [contRes, tempRes, cliRes, parcRes] = await Promise.all([
        axios.get(`${API}/contratos`, { headers }),
        axios.get(`${API}/contratos/templates`, { headers }),
        axios.get(`${API}/clientes`, { headers }),
        axios.get(`${API}/parceiros`, { headers }),
      ]);
      setContratos(contRes.data);
      setTemplates(tempRes.data);
      setClientes(cliRes.data);
      setParceiros(parcRes.data);
    } catch (err) { console.error(err); }
  };

  const listaFiltrada = tipoDestinatario === 'cliente'
    ? clientes.filter(c => (c.nome_fantasia || c.razao_social || '').toLowerCase().includes(buscaCliente.toLowerCase()))
    : parceiros.filter(p => (p.nome || '').toLowerCase().includes(buscaCliente.toLowerCase()));

  const templatesDoTipo = templates.filter(t => !t.tipo || t.tipo === tipoDestinatario);

  const selecionarDestinatario = (item) => {
    if (tipoDestinatario === 'cliente') {
      setFormEnviar(prev => ({ ...prev, cliente_id: item.id, parceiro_id: '' }));
    } else {
      setFormEnviar(prev => ({ ...prev, parceiro_id: item.id, cliente_id: '' }));
    }
    setBuscaCliente(item.nome_fantasia || item.nome);
    setMostrarSugestoes(false);
  };

  const enviarContrato = async () => {
    const temDestinatario = tipoDestinatario === 'cliente' ? formEnviar.cliente_id : formEnviar.parceiro_id;
    const valorObrigatorio = tipoDestinatario === 'cliente' ? formEnviar.valor_mensal : formEnviar.valor_por_rastreador;
    if (!temDestinatario || !formEnviar.template_id || !valorObrigatorio) {
      alert('Preencha todos os campos obrigatórios!'); return;
    }
    setSalvando(true);
    try {
      const res = await axios.post(`${API}/contratos/enviar`, { ...formEnviar, tipo_destinatario: tipoDestinatario }, { headers });
      setLinkGerado(res.data);
      carregarDados();
    } catch (err) { alert(err.response?.data?.erro || 'Erro ao enviar contrato'); }
    setSalvando(false);
  };

  const salvarTemplate = async () => {
    if (!formTemplate.nome || !formTemplate.conteudo) { alert('Preencha nome e conteúdo!'); return; }
    setSalvando(true);
    try {
      if (templateEditando) {
        await axios.put(`${API}/contratos/templates/${templateEditando.id}`, formTemplate, { headers });
      } else {
        await axios.post(`${API}/contratos/templates`, formTemplate, { headers });
      }
      setModalTemplate(false);
      setTemplateEditando(null);
      setFormTemplate({ nome: '', conteudo: '', tipo: 'cliente' });
      carregarDados();
    } catch (err) { alert('Erro ao salvar template'); }
    setSalvando(false);
  };

  const editarTemplate = (t) => {
    setTemplateEditando(t);
    setFormTemplate({ nome: t.nome, conteudo: t.conteudo, tipo: t.tipo || 'cliente' });
    setModalTemplate(true);
  };

  const deletarTemplate = async (id) => {
    if (!window.confirm('Deseja remover este template?')) return;
    await axios.delete(`${API}/contratos/templates/${id}`, { headers });
    carregarDados();
  };

  const abrirEnviar = () => {
    setLinkGerado(null);
    setTipoDestinatario('cliente');
    setFormEnviar({ cliente_id: '', parceiro_id: '', template_id: '', valor_mensal: '', dia_vencimento: '10', prazo_meses: '12', data_inicio: new Date().toISOString().split('T')[0], valor_por_rastreador: '', renovacao_automatica: true, observacao: '' });
    setBuscaCliente('');
    setModalEnviar(true);
  };

  const statusCor = (status) => {
    if (status === 'assinado') return { bg: '#E1F5EE', cor: '#0F6E56' };
    return { bg: '#FAEEDA', cor: '#633806' };
  };

  const inputStyle = { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' };
  const labelStyle = { fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <Sidebar aberta={sidebarAberta} setAberta={setSidebarAberta} />

      <div style={{ background: '#1D9E75', padding: '0 24px', height: '60px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 500, boxShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button onClick={() => setSidebarAberta(!sidebarAberta)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '22px', color: 'white' }}>☰</button>
          <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>📋 Contratos</span>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          {aba === 'contratos' && (
            <button onClick={abrirEnviar}
              style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: '1px solid rgba(255,255,255,0.4)', borderRadius: '8px', padding: '8px 16px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
              + Enviar Contrato
            </button>
          )}
          {aba === 'templates' && (
            <button onClick={() => { setTemplateEditando(null); setFormTemplate({ nome: '', conteudo: '', tipo: 'cliente' }); setModalTemplate(true); }}
              style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: '1px solid rgba(255,255,255,0.4)', borderRadius: '8px', padding: '8px 16px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
              + Novo Template
            </button>
          )}
        </div>
      </div>

      <div style={{ marginTop: '60px', padding: '24px' }}>
        <div style={{ display: 'flex', gap: '8px', marginBottom: '20px', background: 'white', borderRadius: '12px', padding: '8px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
          {[{ key: 'contratos', label: '📄 Contratos Enviados' }, { key: 'templates', label: '📝 Templates' }].map(a => (
            <button key={a.key} onClick={() => setAba(a.key)} style={{ background: aba === a.key ? '#1D9E75' : 'transparent', color: aba === a.key ? 'white' : '#666', border: 'none', borderRadius: '8px', padding: '8px 20px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>{a.label}</button>
          ))}
        </div>

        {aba === 'contratos' && (
          <div>
            <div style={{ marginBottom: '16px' }}>
              <input placeholder="🔍 Buscar por cliente ou template..." value={busca} onChange={e => setBusca(e.target.value)}
                style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' }} />
            </div>
            <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead style={{ background: '#f8f8f8' }}>
                  <tr>{['Destinatário', 'Tipo', 'Template', 'Status', 'Enviado em', 'Assinado por', 'Ações'].map(h => (
                    <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: '12px', color: '#666', fontWeight: '600', borderBottom: '1px solid #eee' }}>{h}</th>
                  ))}</tr>
                </thead>
                <tbody>
                  {contratos.length === 0 ? (
                    <tr><td colSpan="7" style={{ padding: '48px', textAlign: 'center', color: '#999' }}>
                      <div style={{ fontSize: '32px', marginBottom: '12px' }}>📄</div>
                      Nenhum contrato enviado ainda
                    </td></tr>
                  ) : contratos.filter(c => !busca || (c.cliente_nome||'').toLowerCase().includes(busca.toLowerCase()) || (c.template_nome||'').toLowerCase().includes(busca.toLowerCase())).map((c, i) => {
                    const sc = statusCor(c.status);
                    return (
                      <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                        <td style={{ padding: '12px 16px', fontSize: '14px', fontWeight: '500' }}>{c.cliente_nome}</td>
                        <td style={{ padding: '12px 16px' }}>
                          <span style={{ background: c.tipo_destinatario === 'parceiro' ? '#EEEDFE' : '#E1F5EE', color: c.tipo_destinatario === 'parceiro' ? '#3C3489' : '#0F6E56', padding: '3px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '600' }}>
                            {c.tipo_destinatario === 'parceiro' ? '🤝 Parceiro' : '👤 Cliente'}
                          </span>
                        </td>
                        <td style={{ padding: '12px 16px', fontSize: '13px', color: '#666' }}>{c.template_nome}</td>
                        <td style={{ padding: '12px 16px' }}><span style={{ background: sc.bg, color: sc.cor, padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '600' }}>{c.status === 'assinado' ? '✅ Assinado' : '⏳ Pendente'}</span></td>
                        <td style={{ padding: '12px 16px', fontSize: '12px', color: '#666' }}>{new Date(c.criado_em).toLocaleDateString('pt-BR')}</td>
                        <td style={{ padding: '12px 16px', fontSize: '12px', color: '#666' }}>
                          {c.assinado_por ? (
                            <div>
                              <div style={{ fontWeight: '500', color: '#333' }}>{c.assinado_por}</div>
                              <div style={{ fontSize: '11px' }}>{new Date(c.assinado_em).toLocaleString('pt-BR')}</div>
                            </div>
                          ) : '—'}
                        </td>
                        <td style={{ padding: '12px 16px' }}>
                          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                            <a href={`https://b3rastreamento.com.br/assinar-contrato/${c.token}`} target="_blank" rel="noreferrer"
                              style={{ background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '6px', padding: '6px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: '500', textDecoration: 'none' }}>
                              🔗 Link
                            </a>
                            {c.status === 'assinado' && (
                              <a href={`https://b3rastreamento.com.br/assinar-contrato/${c.token}`} target="_blank" rel="noreferrer"
                                style={{ background: '#E1F5EE', color: '#0F6E56', border: 'none', borderRadius: '6px', padding: '6px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: '500', textDecoration: 'none' }}>
                                📄 PDF
                              </a>
                            )}
                            <button onClick={() => {
                              const link = `https://wa.me/55${(c.cliente_whatsapp||'').replace(/\D/g, '')}?text=${encodeURIComponent(`Olá! Segue o link para assinar seu contrato: https://b3rastreamento.com.br/assinar-contrato/${c.token}`)}`;
                              window.open(link, '_blank');
                            }} style={{ background: '#E1F5EE', color: '#0F6E56', border: 'none', borderRadius: '6px', padding: '6px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}>
                              📱 WA
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {aba === 'templates' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {templates.length === 0 ? (
              <div style={{ background: 'white', borderRadius: '12px', padding: '48px', textAlign: 'center', color: '#999', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
                <div style={{ fontSize: '32px', marginBottom: '12px' }}>📝</div>
                Nenhum template cadastrado
              </div>
            ) : templates.map((t, i) => (
              <div key={i} style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                    <div style={{ fontWeight: '600', fontSize: '15px', color: '#333' }}>{t.nome}</div>
                    <span style={{ background: t.tipo === 'parceiro' ? '#EEEDFE' : '#E1F5EE', color: t.tipo === 'parceiro' ? '#3C3489' : '#0F6E56', padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '600' }}>
                      {t.tipo === 'parceiro' ? '🤝 Parceiro' : '👤 Cliente'}
                    </span>
                  </div>
                  <div style={{ fontSize: '12px', color: '#999' }}>{t.conteudo.substring(0, 100)}...</div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={() => editarTemplate(t)} style={{ background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '6px', padding: '8px 14px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>✏️ Editar</button>
                  <button onClick={() => deletarTemplate(t.id)} style={{ background: '#FCEBEB', color: '#A32D2D', border: 'none', borderRadius: '6px', padding: '8px 14px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>🗑️</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {modalEnviar && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '560px', maxWidth: '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ padding: '20px 24px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, background: 'white', zIndex: 1 }}>
              <h2 style={{ margin: 0, fontSize: '18px' }}>📋 Enviar Contrato</h2>
              <button onClick={() => { setModalEnviar(false); setLinkGerado(null); }} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#999' }}>×</button>
            </div>

            {linkGerado ? (
              <div style={{ padding: '24px' }}>
                <div style={{ background: '#E1F5EE', borderRadius: '12px', padding: '20px', textAlign: 'center', marginBottom: '20px' }}>
                  <div style={{ fontSize: '32px', marginBottom: '8px' }}>✅</div>
                  <div style={{ fontWeight: '700', color: '#0F6E56', fontSize: '16px' }}>Contrato gerado com sucesso!</div>
                </div>
                <div style={{ marginBottom: '16px' }}>
                  <label style={labelStyle}>Link do contrato</label>
                  <div style={{ background: '#f8f8f8', borderRadius: '8px', padding: '12px', fontSize: '13px', wordBreak: 'break-all', color: '#333' }}>
                    {linkGerado.link}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <button onClick={() => { navigator.clipboard.writeText(linkGerado.link); alert('Link copiado!'); }}
                    style={{ flex: 1, background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '8px', padding: '12px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
                    📋 Copiar Link
                  </button>
                  <a href={linkGerado.whatsapp_link} target="_blank" rel="noreferrer"
                    style={{ flex: 1, background: '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', padding: '12px', cursor: 'pointer', fontWeight: '600', fontSize: '14px', textDecoration: 'none', textAlign: 'center' }}>
                    📱 Enviar WhatsApp
                  </a>
                </div>
              </div>
            ) : (
              <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '16px' }}>

                {/* Tipo de destinatário */}
                <div>
                  <label style={labelStyle}>Tipo de contrato *</label>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button onClick={() => { setTipoDestinatario('cliente'); setBuscaCliente(''); setFormEnviar(prev => ({ ...prev, cliente_id: '', parceiro_id: '', template_id: '' })); }}
                      style={{ flex: 1, padding: '10px', border: `2px solid ${tipoDestinatario === 'cliente' ? '#1D9E75' : '#ddd'}`, borderRadius: '8px', background: tipoDestinatario === 'cliente' ? '#E1F5EE' : 'white', color: tipoDestinatario === 'cliente' ? '#0F6E56' : '#666', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>
                      👤 Cliente
                    </button>
                    <button onClick={() => { setTipoDestinatario('parceiro'); setBuscaCliente(''); setFormEnviar(prev => ({ ...prev, cliente_id: '', parceiro_id: '', template_id: '' })); }}
                      style={{ flex: 1, padding: '10px', border: `2px solid ${tipoDestinatario === 'parceiro' ? '#3C3489' : '#ddd'}`, borderRadius: '8px', background: tipoDestinatario === 'parceiro' ? '#EEEDFE' : 'white', color: tipoDestinatario === 'parceiro' ? '#3C3489' : '#666', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>
                      🤝 Parceiro
                    </button>
                  </div>
                </div>

                <div style={{ position: 'relative' }}>
                  <label style={labelStyle}>{tipoDestinatario === 'cliente' ? 'Cliente' : 'Parceiro'} *</label>
                  <input type="text" placeholder={`Buscar ${tipoDestinatario}...`} value={buscaCliente}
                    onChange={e => { setBuscaCliente(e.target.value); setMostrarSugestoes(true); setFormEnviar(prev => ({ ...prev, cliente_id: '', parceiro_id: '' })); }}
                    onFocus={() => setMostrarSugestoes(true)}
                    onBlur={() => setTimeout(() => setMostrarSugestoes(false), 200)}
                    style={inputStyle} />
                  {mostrarSugestoes && buscaCliente && listaFiltrada.length > 0 && (
                    <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #ddd', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 100, maxHeight: '200px', overflowY: 'auto' }}>
                      {listaFiltrada.map((item, i) => (
                        <div key={i} onMouseDown={() => selecionarDestinatario(item)} style={{ padding: '10px 14px', cursor: 'pointer', fontSize: '14px', borderBottom: '1px solid #f5f5f5' }}
                          onMouseEnter={e => e.currentTarget.style.background = '#E1F5EE'}
                          onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                          {tipoDestinatario === 'cliente' ? '👤' : '🤝'} {item.nome_fantasia || item.nome}
                        </div>
                      ))}
                    </div>
                  )}
                  {(formEnviar.cliente_id || formEnviar.parceiro_id) && <div style={{ fontSize: '11px', color: '#1D9E75', marginTop: '4px' }}>✅ Selecionado</div>}
                </div>

                <div>
                  <label style={labelStyle}>Template *</label>
                  <select value={formEnviar.template_id} onChange={e => setFormEnviar(prev => ({ ...prev, template_id: e.target.value }))} style={{ ...inputStyle, background: 'white' }}>
                    <option value="">Selecione o template...</option>
                    {templatesDoTipo.map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
                  </select>
                  {templates.length > 0 && templatesDoTipo.length === 0 && (
                    <div style={{ fontSize: '11px', color: '#E67E22', marginTop: '4px' }}>⚠️ Nenhum template cadastrado para {tipoDestinatario === 'parceiro' ? 'parceiros' : 'clientes'}. Crie um na aba Templates.</div>
                  )}
                </div>

                {tipoDestinatario === 'cliente' ? (
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                    <div>
                      <label style={labelStyle}>Valor mensal (R$) *</label>
                      <input type="number" placeholder="Ex: 89.90" value={formEnviar.valor_mensal} onChange={e => setFormEnviar(prev => ({ ...prev, valor_mensal: e.target.value }))} style={inputStyle} />
                    </div>
                    <div>
                      <label style={labelStyle}>Dia de vencimento</label>
                      <select value={formEnviar.dia_vencimento} onChange={e => setFormEnviar(prev => ({ ...prev, dia_vencimento: e.target.value }))} style={{ ...inputStyle, background: 'white' }}>
                        {[5,10,15,20,25].map(d => <option key={d} value={d}>Dia {d}</option>)}
                      </select>
                    </div>
                    <div>
                      <label style={labelStyle}>Prazo (meses)</label>
                      <select value={formEnviar.prazo_meses} onChange={e => setFormEnviar(prev => ({ ...prev, prazo_meses: e.target.value }))} style={{ ...inputStyle, background: 'white' }}>
                        {[6,12,24,36].map(m => <option key={m} value={m}>{m} meses</option>)}
                      </select>
                    </div>
                    <div>
                      <label style={labelStyle}>Data de início</label>
                      <input type="date" value={formEnviar.data_inicio} onChange={e => setFormEnviar(prev => ({ ...prev, data_inicio: e.target.value }))} style={inputStyle} />
                    </div>
                  </div>
                ) : (
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                    <div>
                      <label style={labelStyle}>Valor por rastreador (R$/mês) *</label>
                      <input type="number" placeholder="Ex: 15.00" value={formEnviar.valor_por_rastreador} onChange={e => setFormEnviar(prev => ({ ...prev, valor_por_rastreador: e.target.value }))} style={inputStyle} />
                      <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>Cobrado por rastreador ativo cadastrado</div>
                    </div>
                    <div>
                      <label style={labelStyle}>Dia de vencimento</label>
                      <select value={formEnviar.dia_vencimento} onChange={e => setFormEnviar(prev => ({ ...prev, dia_vencimento: e.target.value }))} style={{ ...inputStyle, background: 'white' }}>
                        {[5,10,15,20,25].map(d => <option key={d} value={d}>Dia {d}</option>)}
                      </select>
                    </div>
                    <div>
                      <label style={labelStyle}>Data de início</label>
                      <input type="date" value={formEnviar.data_inicio} onChange={e => setFormEnviar(prev => ({ ...prev, data_inicio: e.target.value }))} style={inputStyle} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingTop: '20px' }}>
                      <input type="checkbox" id="renovacao" checked={formEnviar.renovacao_automatica} onChange={e => setFormEnviar(prev => ({ ...prev, renovacao_automatica: e.target.checked }))} style={{ width: '18px', height: '18px', cursor: 'pointer' }} />
                      <label htmlFor="renovacao" style={{ fontSize: '13px', color: '#333', cursor: 'pointer', fontWeight: '500' }}>Renovação automática</label>
                    </div>
                  </div>
                )}

                <div>
                  <label style={labelStyle}>Observações (opcional — entra automaticamente no contrato)</label>
                  <textarea value={formEnviar.observacao} onChange={e => setFormEnviar(prev => ({ ...prev, observacao: e.target.value }))} placeholder="Ex: equipamento instalado em caráter de cortesia por 30 dias..." rows={3} style={{ ...inputStyle, resize: 'vertical' }} />
                </div>

                <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                  <button onClick={() => setModalEnviar(false)} style={{ background: '#f0f0f0', color: '#666', border: 'none', borderRadius: '8px', padding: '10px 20px', cursor: 'pointer', fontWeight: '600' }}>Cancelar</button>
                  <button onClick={enviarContrato} disabled={salvando} style={{ background: salvando ? '#ccc' : '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 24px', cursor: salvando ? 'not-allowed' : 'pointer', fontWeight: '600' }}>
                    {salvando ? '⏳ Gerando...' : '📋 Gerar Contrato'}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {modalTemplate && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '800px', maxWidth: '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ padding: '20px 24px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, background: 'white', zIndex: 1 }}>
              <h2 style={{ margin: 0, fontSize: '18px' }}>{templateEditando ? '✏️ Editar Template' : '📝 Novo Template'}</h2>
              <button onClick={() => setModalTemplate(false)} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#999' }}>×</button>
            </div>
            <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={labelStyle}>Nome do template *</label>
                  <input type="text" placeholder="Ex: Contrato White-Label" value={formTemplate.nome} onChange={e => setFormTemplate(prev => ({ ...prev, nome: e.target.value }))} style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Tipo de contrato *</label>
                  <select value={formTemplate.tipo} onChange={e => setFormTemplate(prev => ({ ...prev, tipo: e.target.value }))} style={{ ...inputStyle, background: 'white' }}>
                    <option value="cliente">👤 Para Clientes</option>
                    <option value="parceiro">🤝 Para Parceiros</option>
                  </select>
                </div>
              </div>
              <div>
                <label style={labelStyle}>Conteúdo do contrato *</label>
                <div style={{ fontSize: '11px', color: '#999', marginBottom: '6px' }}>
                  {formTemplate.tipo === 'parceiro' ? (
                    <>Variáveis para parceiro: <strong>{'{{cliente_nome}}'}</strong> {'{{cliente_documento}}'} {'{{cliente_endereco}}'} <strong>{'{{valor_por_rastreador}}'}</strong> {'{{dia_vencimento}}'} {'{{renovacao_automatica}}'} {'{{data_inicio}}'} {'{{observacao}}'}</>
                  ) : (
                    <>Variáveis para cliente: <strong>{'{{cliente_nome}}'}</strong> {'{{cliente_documento}}'} {'{{cliente_endereco}}'} <strong>{'{{valor_mensal}}'}</strong> {'{{dia_vencimento}}'} {'{{prazo_meses}}'} {'{{data_inicio}}'} {'{{data_fim}}'} {'{{observacao}}'}</>
                  )}
                </div>
                <textarea value={formTemplate.conteudo} onChange={e => setFormTemplate(prev => ({ ...prev, conteudo: e.target.value }))}
                  rows={20} style={{ ...inputStyle, resize: 'vertical', fontFamily: 'monospace', fontSize: '13px' }}
                  placeholder="Digite o texto do contrato aqui..." />
              </div>
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                <button onClick={() => setModalTemplate(false)} style={{ background: '#f0f0f0', color: '#666', border: 'none', borderRadius: '8px', padding: '10px 20px', cursor: 'pointer', fontWeight: '600' }}>Cancelar</button>
                <button onClick={salvarTemplate} disabled={salvando} style={{ background: salvando ? '#ccc' : '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 24px', cursor: salvando ? 'not-allowed' : 'pointer', fontWeight: '600' }}>
                  {salvando ? '⏳ Salvando...' : '✅ Salvar Template'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Contratos;